module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Lausanne-5b792ad1eb895e975526040fe6a53344.svg";